<template>
    <div v-if="stage" class="px-4">
        <v-row>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Ruta al email: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.email_location"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.email_location"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    v-model="stage.subject"
                    label="Asunto"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.subject"
                    :background-color="showErrors && !stage.subject ? '#DC0B0B1A' : 'white'"
                    @change="computeStage">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <!-- can be empty -->
                <v-textarea
                    v-model="stage.body"
                    label="Cuerpo"
                    outlined
                    rows="5"
                    hide-details="auto"
                    class="small_scrollbar"
                    :error="false"
                    :background-color="showErrors && false ? '#DC0B0B1A' : 'white'"
                    @change="computeStage">
                </v-textarea>
            </v-col>
        </v-row>
        
    </div>
</template>

<script>
import { SendThroughEmail } from '@/modules/document/domain/WorkflowTemplate';
import { DOCS_FIELD_MAP_SHOW } from "@/modules/document/domain/Document";
import RouteInBagSelectorComponent from '@/modules/document/infra/RouteInBagSelectorComponent';

export default {
    name:'SendThroughEmailDetailComponent',
    components: {
        RouteInBagSelectorComponent
    },
    props:{
        stage: {
            type: SendThroughEmail,
            default: false,
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        my_bag: {
            type: Object,
            default: () => {}
        }
    },
    data(){
        return {
        }
    },
    mounted(){
        console.log(this.stage);
    },
    methods:{
        formatField(field) {
            return DOCS_FIELD_MAP_SHOW[field] || field;
        },
        computeStage(){
            this.$emit('compute-stage');
        }
    },
    computed:{
        
    },
    beforeDestroy() {
        // Remove the stylesheet when the component is destroyed
        // if (this.cssLink && document.head.contains(this.cssLink)) {
        // document.head.removeChild(this.cssLink);
        // }
    }
}
</script>

<style scoped >
/*@import url('https://unpkg.com/json-schema-editor-vue@2.3.0/lib/json-schema-editor-vue.css');*/
.preaty__card {
    border-radius: 5px;
}
.small_scrollbar >>> textarea {
    scrollbar-width: thin;
}
.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}
</style>